// Module
var code = "<div class=\"ui-grid-cell-contents u-sizeFullWidth u-textRight\" ng-bind=\"row.entity[col.field] | invEmpty\">\n</div>";
// Exports
module.exports = code;